const FILTERS_TRANSLATION_PREFIX = 'STATIC.PAGES.ANOMALY_ANALYSIS.FILTERS';
const TIME_SELECTORS_TRANSLATION_PREFIX = `${FILTERS_TRANSLATION_PREFIX}.TIMES`;

export const TimeSelectors = {
    DAY_BY_DAY: 'DAY_BY_DAY',
    WEEK_BY_WEEK: 'WEEK_BY_WEEK',
    MONTH_BY_MONTH: 'MONTH_BY_MONTH',
};

export const TIME_OPTIONS = Object.keys(TimeSelectors).map(value => ({
    value,
    label: `${TIME_SELECTORS_TRANSLATION_PREFIX}.${value}`,
}));

export const TimePeriods = {
    [TimeSelectors.DAY_BY_DAY]: { amount: 1, unit: 'days' },
    [TimeSelectors.WEEK_BY_WEEK]: { amount: 7, unit: 'days' },
    [TimeSelectors.MONTH_BY_MONTH]: { amount: 1, unit: 'months' },
};

export const Dimensions = {
    APP: 'APP',
    SOURCE: 'SOURCE',
    PLATFORM: 'PLATFORM',
    CAMPAIGN: 'CAMPAIGN',
    COUNTRY: 'COUNTRY',
};

const DimensionConfig = {
    [Dimensions.APP]: { label: 'STATIC.APP', apiName: 'app' },
    [Dimensions.SOURCE]: { label: `${FILTERS_TRANSLATION_PREFIX}.SOURCE`, apiName: 'source' },
    [Dimensions.PLATFORM]: { label: 'STATIC.PLATFORM', apiName: 'platform' },
    [Dimensions.CAMPAIGN]: { label: 'STATIC.CAMPAIGN', apiName: 'adn_campaign_name' },
    [Dimensions.COUNTRY]: { label: 'STATIC.COUNTRY', apiName: 'country_field' },
};

export const DIMENSIONS_OPTIONS = Object.entries(DimensionConfig).map(([value, { label }]) => ({
    value,
    label,
}));

const FILTERS_DIMENSIONS = [Dimensions.APP, Dimensions.SOURCE, Dimensions.COUNTRY];

export const FILTERS_OPTIONS = FILTERS_DIMENSIONS.map(key => ({
    value: key,
    label: DimensionConfig[key].label,
    apiName: DimensionConfig[key].apiName,
}));

const MetricType = {
    COLOR: 'COLOR',
    SIZE: 'SIZE',
};

export const MetricsTypes = {
    REVENUE_7D: [MetricType.COLOR, MetricType.SIZE],
    ROI_1D: [MetricType.COLOR],
    ROI_7D: [MetricType.COLOR],
    ROI_14D: [MetricType.COLOR],
    OCVR: [MetricType.COLOR],
    ECPI: [MetricType.COLOR],
    INSTALLS: [MetricType.COLOR, MetricType.SIZE],
    COST: [MetricType.SIZE],
    IMPRESSIONS: [MetricType.SIZE],
    CLICKS: [MetricType.SIZE],
};

const toOption = key => ({ value: key, label: `STATIC.${key}` });

export const { color: COLOR_METRICS_OPTIONS, size: SIZE_METRICS_OPTIONS } = Object.entries(MetricsTypes).reduce(
    (acc, [key, types]) => {
        if (types.includes(MetricType.COLOR)) acc.color.push(toOption(key));
        if (types.includes(MetricType.SIZE)) acc.size.push(toOption(key));

        return acc;
    },
    { color: [], size: [] }
);

export const PerformanceColor = {
    NO_DATA: '#D1D5DB',
    POOR: '#E85D5D',
    BELOW_AVG: '#E8A45D',
    NEUTRAL: '#E2B837',
    GOOD: '#5DB87A',
    EXCELLENT: '#3DA66B',
};
